import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'

// 管理支付页面之间需要延续的少量会话状态。
export const usePayStore = defineStore(
    'payStore',
    () => {
        // 用于判断是否同一个订单号
        const orderId = ref('')
        const orderIdAction = reactive({
            save(value: string) {
                orderId.value = value
            },
            clear() {
                orderId.value = ''
            },
            data: orderId,
        })

        const pGid = ref('')
        const pGidAction = reactive({
            save(value: string) {
                pGid.value = value
            },
            clear() {
                pGid.value = ''
            },
            data: pGid,
        })

        return {
            orderId,
            orderIdAction,
            pGid,
            pGidAction,
        }
    },
    {
        persist: {
            enabled: true,
            strategies: [
                { key: 'payStore', storage: sessionStorage, paths: ['orderId', 'pGid'] },
            ],
        },
    }
)
